import { categories } from "@/mocks/categories";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

const ICON_TONES = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-700",
];

export default function CategorySection() {
  const visible = categories.filter((category) => category.id !== "all");

  return (
    <section
      id="categories"
      className="scroll-mt-20 bg-background-50 px-4 py-16 md:px-8 md:py-24"
    >
      <Reveal>
        <SectionHeading
          eyebrow="Categories"
          title="话题分类，按兴趣直达现场"
          description="六大板块各管一块，娱乐、影视、社会、科技与生活分得清清楚楚，挑你在意的方向往下看就好。"
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {visible.map((category, index) => (
          <Reveal key={category.id} delay={index * 60}>
            <a
              href="#topics"
              className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-100/70 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:bg-background-50"
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-md ${
                    ICON_TONES[index % ICON_TONES.length]
                  }`}
                >
                  <i className={`${category.icon} text-2xl`} aria-hidden="true" />
                </span>
                <span className="rounded-full bg-background-200 px-2.5 py-1 text-xs font-medium text-foreground-700">
                  {category.count} 个话题
                </span>
              </div>

              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600">
                {category.name}
              </h3>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">
                {category.desc}
              </p>

              <span className="mt-5 flex items-center gap-1 text-xs font-medium text-primary-600">
                进入话题现场
                <i
                  className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"
                  aria-hidden="true"
                />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}